import { useState } from 'react';

import { Box, Menu, MenuItem, styled } from '@mui/material';
import Button from '@mui/material/Button';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Loading from '../../elements/loading/Loading';

const StyledMenuItem = styled(MenuItem)({
  minWidth: 200,
});

const SubToExtButton = ({ projects, onMenuOpen, onSubscribe }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = async (event) => {
    setAnchorEl(event.currentTarget);
    setLoading(true);
    await onMenuOpen();
    setLoading(false);
  };

  const handleCloseMenu = () => setAnchorEl(null);
  const handleSubscribe = (projectId) => {
    onSubscribe(projectId);
    handleCloseMenu();
  };

  return (
    <>
      <Button onClick={(e) => handleOpenMenu(e)}>
        {t('addToProject', { ns: 'buttons' })}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleCloseMenu}
        getcontentanchorel={null}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      >
        {loading ? (
          <StyledMenuItem>
            <Box sx={{ mx: 'auto' }}>
              <Loading />
            </Box>
          </StyledMenuItem>
        ) : projects ? (
          !isEmpty(projects) ? (
            projects.map((project) => (
              <StyledMenuItem
                key={project.id}
                onClick={() => handleSubscribe(project.id)}
              >
                {project.name}
              </StyledMenuItem>
            ))
          ) : (
            <StyledMenuItem disabled>
              {t('noFound', {
                ns: 'descriptions',
                text: t('project', { ns: 'project' }),
              })}
            </StyledMenuItem>
          )
        ) : (
          <StyledMenuItem disabled>
            {t('projectLoadError', {
              ns: 'notifications',
            })}
          </StyledMenuItem>
        )}
      </Menu>
    </>
  );
};

SubToExtButton.propTypes = {
  projects: PropTypes.array.isRequired,
  onMenuOpen: PropTypes.func.isRequired,
  onSubscribe: PropTypes.func.isRequired,
};

export default SubToExtButton;
